import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-extracted-principal-info',
    templateUrl: './extracted-principal-info.component.html',
    styleUrls: ['./extracted-principal-info.component.scss'],
    standalone: false
})
export class ExtractedPrincipalInfoComponent {
  @Input() isESOE!: boolean;
  @Input() districtName!: string;
  @Input() campusName!: string;
  @Input() principalName!: string;
  @Input() principalEmail!: string;
}
